import { Apollo } from 'apollo-angular';
import { Entity } from '../models/entity.model';
import { Observable } from 'rxjs';
import { AbstractService, Criteria, Fragment } from './abstract-service';
import { map } from 'rxjs/operators';
import { plainToClass } from 'class-transformer';
import {ClassConstructor} from 'class-transformer/types/interfaces';
import {FetchPolicy} from '@apollo/client/core';

export abstract class AbstractEntityService<T extends Entity> extends AbstractService {

    protected constructor(protected apollo: Apollo,
                          protected domainName: string,
                          protected entityName: string,
                          protected entityClass: ClassConstructor<T>,
                          protected debugMode?: boolean) {
        super(apollo, domainName, entityName, debugMode);
    }

    protected findAll(projection: string[], fragments?: Fragment[], policy?: FetchPolicy): Observable<T[]> {
        return this.queryForResults('all', null, projection, fragments, policy);
    }

    protected getById(id: string, projection: string[], fragments?: Fragment[]): Observable<T> {
        return this.queryForResult('byId', {id}, projection, fragments);
    }

    protected queryForResults(queryName: string, criteria?: Criteria, projection?: string[],
                              fragments?: Fragment[], policy?: FetchPolicy): Observable<T[]> {
        return this.query(queryName, criteria, projection, fragments, policy)
            .pipe(
                map(result => result.data[this.domainName][this.entityName][queryName]),
                map(result => plainToClass<T, any>(this.entityClass, result as T[]))
            );
    }

    protected queryForResult(queryName: string, criteria?: Criteria,
                             projection?: string[], fragments?: Fragment[]): Observable<T> {
        return this.query(queryName, criteria, projection, fragments)
            .pipe(
                map(result => result.data[this.domainName][this.entityName][queryName]),
                map(result => plainToClass<T, any>(this.entityClass, result as T))
            );
    }
}
